export default __webpack_public_path__ + "static/media/pega_border.4e966af5.png";